import React from 'react';
import AdManager from '../components/AdManager';
import RoleBadge from '../components/RoleBadge';
import { useApp } from '../context/AppContext';
import { Megaphone, ShieldAlert } from 'lucide-react';

export default function OwnerAds() {
  const { user } = useApp();
  if (user?.role !== 'owner') {
    return (
      <div className="py-10"><div className="card-shell p-6 max-w-[560px]"><div className="flex items-center gap-2 text-[#ffcf52]"><ShieldAlert className="w-5 h-5" /> <span className="font-semibold">Owner only</span></div><p className="text-white/65 mt-2 text-[14px]">Platform-wide ads can only be managed by the Owner.</p></div></div>
    );
  }
  return (
    <div>
      <div className="flex items-center gap-2"><RoleBadge role="owner" /><span className="text-white/45 text-[12px]">Platform ad control</span></div>
      <h1 className="font-display text-[32px] md:text-[40px] mt-3 leading-none flex items-center gap-3"><Megaphone className="w-7 h-7 text-[#ffcf52]" /> Ads & Ad Server</h1>
      <p className="text-white/60 text-[14px] mt-1">Platform banners, pre-rolls, external ad server snippets and a full view of every ad across VidCreForge.</p>
      <div className="mt-8"><AdManager ownerMode /></div>
    </div>
  );
}
